import axiosClient from "./axiosClient";

export interface KotConfig {
  _id?: string;
  brandId: string;
  locationId: string;
  associatedStoreIds: string[];
  region?: string;
  isActive?: boolean;
  terminalName?: string;
  terminalType?: string; // "KDS" | "KOT_SLIP_PRINTER"
  accessCode?: string;
  createdAt?: string;
  updatedAt?: string;
}

const kotApi = {
  getKotConfigs(params: { page?: number; limit?: number; brandId?: string; locationId?: string }): Promise<any> {
    const { page = 1, limit = 20, brandId = "", locationId = "" } = params;
    return axiosClient.get(
      `/kot/getKotConfigs?page=${page}&limit=${limit}&brandId=${brandId}&locationId=${locationId}`
    );
  },

  addOrUpdateKotConfig(data: KotConfig): Promise<any> {
    return axiosClient.post("/kot/addOrUpdateMultiStoreKotConfig", data);
  },

  deleteKotConfig(id: string): Promise<any> {
    return axiosClient.delete(`/kot/deleteKotConfig?id=${id}`);
  },
};

export default kotApi;
